import React from 'react';
import { Grid, Card, CardContent, CardActions, Typography, List, ListItem, ListItemIcon, ListItemText, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PLAN_TYPE } from '../../constants/subscriptionTypes';

export default function FreePlan({ subscription }) {
  const isCurrent = subscription?.type === PLAN_TYPE.FREE;
  return (
    <Grid item xs={12} md={4}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" gutterBottom>Free Plan</Typography>
          <Typography variant="h4">Free</Typography>
          <List dense>
            <ListItem>
              <ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon>
              <ListItemText primary="ChatGPT,Gemini,Deepseek,Preplixity.ai"/>
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon>
              <ListItemText primary="Generate 3 Presentations per month"/>
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon>
              <ListItemText primary="Smart Search"/>
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon>
              <ListItemText primary="Export bookmarks"/>
            </ListItem>
            <ListItem>
              <ListItemIcon><CheckCircleIcon color="success"/></ListItemIcon>
              <ListItemText primary="Save up to 20 bookmarks"/>
            </ListItem>
          </List>
        </CardContent>
        <CardActions>
          <Button variant="contained" fullWidth disabled>
            {isCurrent ? 'Current Plan' : 'Select Free'}
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
}
